import {
  SpravaOUcastiVerejnosti,
  Subjekty as SubjektyDto,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { Subjekty } from '../../../model/sprievodnyDokument/spravaoUcastiVerejnosti/Subjekty';
import {
  SpravaOUcastiVerejnostiFormData,
} from '../../../model/sprievodnyDokument/spravaoUcastiVerejnosti/SpravaOUcastiVerejnostiFormData';

function mapSubjekty(formSubjects: Subjekty): SubjektyDto {
  return {
    zaujmoveZdruzenia: formSubjects.zaujmoveZdruzenia,
    podnikatelia: formSubjects.podnikatelia,
    mimovladneANeziskoveOrg: formSubjects.mimovladneANeziskoveOrg,
    akademickaAVedeckaObec: formSubjects.akademickaAVedeckaObec,
    cirkvi: formSubjects.cirkvi,
    ine: formSubjects.ine,
    ineText: formSubjects.ineText,
  };
}

export const map = (formData: SpravaOUcastiVerejnostiFormData): SpravaOUcastiVerejnosti => ({
  informovanie: formData.informovanie,
  prerokovanie: formData.prerokovanie,
  odovodnenieZapojenieVerejnosti: formData.odovodnenieZapojenieVerejnosti,

  predbeznaInformacia: formData.predbeznaInformacia,
  legislativnyZamer: formData.legislativnyZamer,
  ineSposobInformovaniaVerejnosti: formData.ineSposobInformovaniaVerejnosti,
  ineSposobInformovaniaVerejnostiText: formData.ineSposobInformovaniaVerejnostiText,

  oprobleme: formData.oprobleme,
  osposobeZapojenia: formData.osposobeZapojenia,
  ocasovomRamci: formData.ocasovomRamci,
  oprocese: formData.oprocese,
  osposobeNalozenia: formData.osposobeNalozenia,
  ineInformacieVerejnosti: formData.ineInformacieVerejnosti,
  ineInformacieVerejnostiText: formData.ineInformacieVerejnostiText,

  formaOsobne: formData.formaOsobne,
  formaUstne: formData.formaUstne,
  formaPisomne: formData.formaPisomne,
  formaIne: formData.formaIne,
  formaIneText: formData.formaIneText,
  formaOdovodnenie: formData.formaOdovodnenie,

  pracovnaSkupina: formData.pracovnaSkupina,
  konferencia: formData.konferencia,
  diskusiaKLegislativnemuProcesu: formData.diskusiaKLegislativnemuProcesu,
  konzultacia: formData.konzultacia,
  pripomienkovanie: formData.pripomienkovanie,
  inePrerokovanieVerejnostou: formData.inePrerokovanieVerejnostou,
  inePrerokovanieVerejnostouText: formData.inePrerokovanieVerejnostouText,

  vyzvane: mapSubjekty(formData.vyzvane),
  zucastnene: mapSubjekty(formData.zucastnene),
  vyzvaneOdovodnenie: formData.vyzvaneOdovodnenie,
  prejaviliZaujem: mapSubjekty(formData.prejaviliZaujem),
  iniciativneZucastnene: mapSubjekty(formData.iniciativneZucastnene),

  organyVerejnejSpravy: formData.organyVerejnejSpravy,
  zaujmoveZdruzenia: formData.zaujmoveZdruzenia,
  podnikatelia: formData.podnikatelia,
  mimovladneANeziskoveOrg: formData.mimovladneANeziskoveOrg,
  akademickaAVedeckaObec: formData.akademickaAVedeckaObec,
  cirkvi: formData.cirkvi,
  ine: formData.ine,
  ineText: formData.ineText,
  sposobNalozeniaOdovodnenie: formData.sposobNalozeniaOdovodnenie,
  vyhodnotenieUcastiOdovodnenie: formData.vyhodnotenieUcastiOdovodnenie,
});

export default map;
